import { Component, Inject, Injector, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { BehaviorSubject } from 'rxjs'
import { AbstractComponent, AlertService, ReportService } from '../../../../public-api'
import { Pager } from '../../../commons/pager'

interface ResponsePerformanceAttendanceTypes {
  createdAt: string;
  channel: string;
  department: string;
  contact: string;
  phone: string;
  user: string;
}

@Component({
    selector: 'modal-report-attendance-fast',
    templateUrl: './modal-report-attendance.v2.component.html',
    // templateUrl: './modal-report-attendance.component.html',
    styleUrls: ['./modal-report-attendance.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalReportAttendanceComponent extends AbstractComponent {
  pager: Pager<ResponsePerformanceAttendanceTypes> =
    new Pager<ResponsePerformanceAttendanceTypes>({ perPage: 10 });
  messageStatus: any;
  attendaceStatus: any;
  searchTerm = '';
  originalList: any[];
  loadingSpinnerSubject = new BehaviorSubject<boolean>(true);
  loadingSpinner$ = this.loadingSpinnerSubject.asObservable();

  constructor(
    injetor: Injector,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _matDialogRef: MatDialogRef<ModalReportAttendanceComponent>,
    private reportService: ReportService,
  ) {
    super(injetor)
  }

  ngOnInit(): void {
    this.getList();
  }

  loadPage(page: number) {
    this.pager.page = page;
    this.getList();
  }

  getList(): void {
    const statusMessage = [
      {
        message: this.t('shared.reportAttendance.statusByChannel'),
        type: 'channel',
      },
      {
        message: this.t('shared.reportAttendance.statusByDepartment'),
        type: 'department',
      },
      {
        message: this.t('shared.reportAttendance.statusByAgent'),
        type: 'user',
      },
      {
        message: this.t('shared.reportAttendance.statusCurrentMonth'),
        type: 'leadCurrent',
      },
      {
        message: this.t('shared.reportAttendance.statusPreviousMonth'),
        type: 'leadPrevious',
      },
    ];

    this.loadingSpinnerSubject.next(true);
    this.messageStatus = statusMessage.find(
      (x) => x.type === this.data.type,
    ) || { message: this.t('shared.reportAttendance.statusDetailed') }
    this.reportService
      .getAttendanceCard({
        ...this.data,
        page: this.pager.page,
        limit: this.pager.perPage,
      })
      .subscribe({
        next: (value: any) => {
          this.pager = value
          this.originalList = value.list
        },
        complete: () => this.loadingSpinnerSubject.next(false),
      })
  }

  onSearch(term: string) {
    this.searchTerm = term
    this.pager.list = this.pager.list.filter((item) => {
      const searchText = term.toLowerCase()
      return (
        item.channel?.toLowerCase().includes(searchText) ||
        item.department?.toLowerCase().includes(searchText) ||
        item.user?.toLowerCase().includes(searchText) ||
        item.contact?.toLowerCase().includes(searchText)
      )
    })

    if (term.trim() === '') {
      this.pager.list = this.originalList
    } else {
      this.pager.list = this.pager.list.filter((item) => {
        const searchText = term.toLowerCase()
        return (
          item.channel?.toLowerCase().includes(searchText) ||
          item.department?.toLowerCase().includes(searchText) ||
          item.user?.toLowerCase().includes(searchText) ||
          item.contact?.toLowerCase().includes(searchText)
        )
      })
    }
  }

  formatPhone(phone: string): string {
    if (!phone) return '';

    const cleaned = ('' + phone).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{2})(\d{2})(\d{4,5})(\d{4})$/);
    if (match) {
      return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`
    }
    return phone
  }

  close(): void {
    this._matDialogRef.close();

  }
}
